import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let EditCampaign = {
    selector: "vcEditCampaign",
    templateUrl:
        "/angular/components/profile/edit-campaign-dialog.component.html",
    bindings: {
        campaign: "=",
    },
    controller: class EditCampaignController {
        // * bindings for typescript compiler *
        public campaign: Campaign;
        // ************************************

        public saving = false;

        private __env: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        private campaignDataProvider: CampaignDataProvider;

        constructor(
            __env: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.campaignDataProvider = CampaignDataProvider;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        updateCampaign(campaign: Campaign): void {
            this.saving = true;
            this.campaignDataProvider
                .updateCampaign({
                    campaignid: campaign.campaignid,
                    campaignname: campaign.campaignname,
                    campaigncreator: campaign.campaigncreator,
                    campaignstatusid: campaign.campaignstatusid,
                    cpid: campaign.cpid,
                })
                .then((json: any) => {
                    this.saving = false;
                    if (json.success) {
                        this.toast.success("Account Name Updated");
                        this.dialog.hide(campaign);
                    } else {
                        this.toast.error();
                    }
                });
        }
    },
};

angular.module("profile").component(EditCampaign.selector, EditCampaign);
